import React from 'react';
import styled, { keyframes } from 'styled-components';

interface SuccessNoticeCardProps {
  title: string;
  content: string;
  timestamp?: string;
}

const SuccessNoticeCard: React.FC<SuccessNoticeCardProps> = ({ title, content, timestamp = 'just now' }) => {
  return (
    <StyledWrapper>
      <div className="card">
        <div className="img success-icon" />
        <div className="textBox">
          <div className="textContent">
            <p className="h1">{title}</p>
            <span className="span">{timestamp}</span>
          </div>
          <p className="p">{content}</p>
        </div>
      </div>
    </StyledWrapper>
  );
};

const slideInFromTop = keyframes`
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

const StyledWrapper = styled.div`
  .card {
    width: 100%;
    height: 80px;
    background: linear-gradient(135deg, #4CAF50, #45a049);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: left;
    backdrop-filter: blur(10px);
    transition: 0.3s ease-in-out;
    animation: ${slideInFromTop} 0.5s ease-out;
    box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.2);
  }

  .card:hover {
    cursor: pointer;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4);
  }

  .img {
    width: 50px;
    height: 50px;
    margin-left: 15px;
    border-radius: 12px;
    transition: 0.3s ease-in-out;
  }

  .success-icon {
    background: linear-gradient(135deg, #66BB6A, #4CAF50);
    position: relative;
  }

  .success-icon::after {
    content: '✓';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 24px;
    font-weight: bold;
  }

  .textBox {
    width: calc(100% - 90px);
    margin-left: 15px;
    color: white;
    font-family: 'Poppins', sans-serif;
  }

  .textContent {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
  }

  .span {
    font-size: 11px;
    opacity: 0.8;
  }

  .h1 {
    font-size: 16px;
    font-weight: 600;
    margin: 0;
  }

  .p {
    font-size: 13px;
    font-weight: 400;
    margin: 0;
    opacity: 0.9;
    line-height: 1.3;
  }
`;

export default SuccessNoticeCard;